import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminOrganizations: build.query<
      GetV2AdminOrganizationsApiResponse,
      GetV2AdminOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations`,
        params: {
          search: queryArg.search,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationId: build.query<
      GetV2AdminOrganizationsByOrganizationIdApiResponse,
      GetV2AdminOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationId: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}`,
        method: "PATCH",
        body: queryArg.updateOrganizationRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdBaa: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdBaaApiResponse,
      PutV2AdminOrganizationsByOrganizationIdBaaApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/baa`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdCoi: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdCoiApiResponse,
      PutV2AdminOrganizationsByOrganizationIdCoiApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/coi`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdCreateSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/create-subscription`,
        method: "POST",
        body: queryArg.createSubscriptionRequest,
      }),
    }),
    putV2AdminOrganizationsByOrganizationIdDataRetention: build.mutation<
      PutV2AdminOrganizationsByOrganizationIdDataRetentionApiResponse,
      PutV2AdminOrganizationsByOrganizationIdDataRetentionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/data-retention`,
        method: "PUT",
        body: queryArg.adminUpdateStatusRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDataSecurity: build.query<
      GetV2AdminOrganizationsByOrganizationIdDataSecurityApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDataSecurityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/data-security`,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDocuments: build.query<
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.pathOrganizationId}/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.queryOrganizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdExtendTrial: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdExtendTrialApiResponse,
      PostV2AdminOrganizationsByOrganizationIdExtendTrialApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/extend-trial`,
        method: "POST",
        body: queryArg.extendTrialRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdForms: build.query<
      GetV2AdminOrganizationsByOrganizationIdFormsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdForms: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdFormsApiResponse,
      PostV2AdminOrganizationsByOrganizationIdFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms`,
        method: "POST",
        body: queryArg.adminFormCreateRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdFormsAndFormId: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/forms/${queryArg.formId}`,
        method: "DELETE",
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdMembers: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdMembersApiResponse,
      PostV2AdminOrganizationsByOrganizationIdMembersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/members`,
        method: "POST",
        body: queryArg.addMemberRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdMembersAndUserId: build.mutation<
      DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiResponse,
      DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}`,
        method: "DELETE",
        params: {
          role: queryArg.role,
        },
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfo:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse,
        GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/membership-info`,
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfo:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/membership-info`,
          method: "PATCH",
          body: queryArg.updateMembershipInfoRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivate:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiResponse,
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/reactivate`,
          method: "POST",
        }),
      }),
    patchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRoles:
      build.mutation<
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse,
        PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/roles`,
          method: "PATCH",
          body: queryArg.updateUserRolesRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMembersAndUserIdRoles:
      build.mutation<
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse,
        PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/members/${queryArg.userId}/roles`,
          method: "POST",
          body: queryArg.addUserRoleRequest,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdMerge: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdMergeApiResponse,
      PostV2AdminOrganizationsByOrganizationIdMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/merge`,
        method: "POST",
        body: queryArg.mergeOrganizationsRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdPatientVisibility: build.query<
      GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse,
      GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/patient-visibility`,
      }),
    }),
    patchV2AdminOrganizationsByOrganizationIdPatientVisibility: build.mutation<
      PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse,
      PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/patient-visibility`,
        method: "PATCH",
        body: queryArg.updatePatientVisibilityRequest,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdProviders: build.query<
      GetV2AdminOrganizationsByOrganizationIdProvidersApiResponse,
      GetV2AdminOrganizationsByOrganizationIdProvidersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/providers`,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrl:
      build.query<
        GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiResponse,
        GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/subscription-dashboard-url`,
        }),
      }),
    postV2AdminOrganizationsByOrganizationIdSyncSubscription: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiResponse,
      PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/sync-subscription`,
        method: "POST",
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdTemplates: build.query<
      GetV2AdminOrganizationsByOrganizationIdTemplatesApiResponse,
      GetV2AdminOrganizationsByOrganizationIdTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/templates`,
      }),
    }),
    postV2AdminOrganizationsByOrganizationIdTemplates: build.mutation<
      PostV2AdminOrganizationsByOrganizationIdTemplatesApiResponse,
      PostV2AdminOrganizationsByOrganizationIdTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.organizationId}/templates`,
        method: "POST",
        body: queryArg.adminTemplateCreateRequest,
      }),
    }),
    deleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateId:
      build.mutation<
        DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse,
        DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/templates/${queryArg.templateId}`,
          method: "DELETE",
        }),
      }),
    putV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateId:
      build.mutation<
        PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse,
        PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/organizations/${queryArg.organizationId}/templates/${queryArg.templateId}`,
          method: "PUT",
          body: queryArg.adminTemplateUpdateRequest,
        }),
      }),
    getV2AdminRoles: build.query<
      GetV2AdminRolesApiResponse,
      GetV2AdminRolesApiArg
    >({
      query: () => ({ url: `/v2/admin/roles` }),
    }),
    getV2ProviderOrganizations: build.query<
      GetV2ProviderOrganizationsApiResponse,
      GetV2ProviderOrganizationsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations` }),
    }),
    postV2ProviderOrganizationsBaa: build.mutation<
      PostV2ProviderOrganizationsBaaApiResponse,
      PostV2ProviderOrganizationsBaaApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/baa`,
        method: "POST",
        body: queryArg.baaRequest,
      }),
    }),
    postV2ProviderOrganizationsBundles: build.mutation<
      PostV2ProviderOrganizationsBundlesApiResponse,
      PostV2ProviderOrganizationsBundlesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/bundles`,
        method: "POST",
        body: queryArg.adminAddBundleRequest,
      }),
    }),
    deleteV2ProviderOrganizationsBundlesByAssignmentId: build.mutation<
      DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiResponse,
      DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/bundles/${queryArg.assignmentId}`,
        method: "DELETE",
      }),
    }),
    putV2ProviderOrganizationsBundlesByAssignmentId: build.mutation<
      PutV2ProviderOrganizationsBundlesByAssignmentIdApiResponse,
      PutV2ProviderOrganizationsBundlesByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/bundles/${queryArg.assignmentId}`,
        method: "PUT",
        body: queryArg.adminAddBundleRequest,
      }),
    }),
    postV2ProviderOrganizationsCoi: build.mutation<
      PostV2ProviderOrganizationsCoiApiResponse,
      PostV2ProviderOrganizationsCoiApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/coi`,
        method: "POST",
        body: queryArg.coiRequest,
      }),
    }),
    postV2ProviderOrganizationsDataRetention: build.mutation<
      PostV2ProviderOrganizationsDataRetentionApiResponse,
      PostV2ProviderOrganizationsDataRetentionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/data-retention`,
        method: "POST",
        body: queryArg.dataRetentionRequest,
      }),
    }),
    getV2ProviderOrganizationsDataSecurity: build.query<
      GetV2ProviderOrganizationsDataSecurityApiResponse,
      GetV2ProviderOrganizationsDataSecurityApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/data-security` }),
    }),
    getV2ProviderOrganizationsForms: build.query<
      GetV2ProviderOrganizationsFormsApiResponse,
      GetV2ProviderOrganizationsFormsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/forms` }),
    }),
    postV2ProviderOrganizationsForms: build.mutation<
      PostV2ProviderOrganizationsFormsApiResponse,
      PostV2ProviderOrganizationsFormsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/forms`,
        method: "POST",
        body: queryArg.providerFormCreateRequest,
      }),
    }),
    deleteV2ProviderOrganizationsFormsByFormId: build.mutation<
      DeleteV2ProviderOrganizationsFormsByFormIdApiResponse,
      DeleteV2ProviderOrganizationsFormsByFormIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/forms/${queryArg.formId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderOrganizationsInvitations: build.query<
      GetV2ProviderOrganizationsInvitationsApiResponse,
      GetV2ProviderOrganizationsInvitationsApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/invitations` }),
    }),
    postV2ProviderOrganizationsInvitations: build.mutation<
      PostV2ProviderOrganizationsInvitationsApiResponse,
      PostV2ProviderOrganizationsInvitationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations`,
        method: "POST",
        body: queryArg.providerInvitationRequest,
      }),
    }),
    postV2ProviderOrganizationsInvitationsAccept: build.mutation<
      PostV2ProviderOrganizationsInvitationsAcceptApiResponse,
      PostV2ProviderOrganizationsInvitationsAcceptApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/accept`,
        method: "POST",
        body: queryArg.providerInvitationAcceptRequest,
      }),
    }),
    getV2ProviderOrganizationsInvitationsValidateByToken: build.query<
      GetV2ProviderOrganizationsInvitationsValidateByTokenApiResponse,
      GetV2ProviderOrganizationsInvitationsValidateByTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/validate/${queryArg.token}`,
      }),
    }),
    deleteV2ProviderOrganizationsInvitationsByInvitationId: build.mutation<
      DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiResponse,
      DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/${queryArg.invitationId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderOrganizationsInvitationsByInvitationId: build.mutation<
      PatchV2ProviderOrganizationsInvitationsByInvitationIdApiResponse,
      PatchV2ProviderOrganizationsInvitationsByInvitationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/${queryArg.invitationId}`,
        method: "PATCH",
        body: queryArg.providerUpdateInvitationRequest,
      }),
    }),
    postV2ProviderOrganizationsInvitationsByInvitationIdResend: build.mutation<
      PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiResponse,
      PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/invitations/${queryArg.invitationId}/resend`,
        method: "POST",
      }),
    }),
    getV2ProviderOrganizationsMembers: build.query<
      GetV2ProviderOrganizationsMembersApiResponse,
      GetV2ProviderOrganizationsMembersApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/members` }),
    }),
    deleteV2ProviderOrganizationsMembersByUserId: build.mutation<
      DeleteV2ProviderOrganizationsMembersByUserIdApiResponse,
      DeleteV2ProviderOrganizationsMembersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdBillingInfo: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/billing-info`,
        method: "PATCH",
        body: queryArg.updateMemberBillingInfoRequest,
      }),
    }),
    postV2ProviderOrganizationsMembersByUserIdBundles: build.mutation<
      PostV2ProviderOrganizationsMembersByUserIdBundlesApiResponse,
      PostV2ProviderOrganizationsMembersByUserIdBundlesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/bundles`,
        method: "POST",
        body: queryArg.adminAddBundleRequest,
      }),
    }),
    deleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentId:
      build.mutation<
        DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse,
        DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/members/${queryArg.userId}/bundles/${queryArg.assignmentId}`,
          method: "DELETE",
        }),
      }),
    putV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentId:
      build.mutation<
        PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse,
        PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/organizations/members/${queryArg.userId}/bundles/${queryArg.assignmentId}`,
          method: "PUT",
          body: queryArg.adminAddBundleRequest,
        }),
      }),
    getV2ProviderOrganizationsMembersByUserIdDetail: build.query<
      GetV2ProviderOrganizationsMembersByUserIdDetailApiResponse,
      GetV2ProviderOrganizationsMembersByUserIdDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/detail`,
      }),
    }),
    getV2ProviderOrganizationsMembersByUserIdMembershipInfo: build.query<
      GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse,
      GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/membership-info`,
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdMembershipInfo: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/membership-info`,
        method: "PATCH",
        body: queryArg.updateMembershipInfoRequest,
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdProfile: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdProfileApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/profile`,
        method: "PATCH",
        body: queryArg.updateMemberProfileRequest,
      }),
    }),
    patchV2ProviderOrganizationsMembersByUserIdRoles: build.mutation<
      PatchV2ProviderOrganizationsMembersByUserIdRolesApiResponse,
      PatchV2ProviderOrganizationsMembersByUserIdRolesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/members/${queryArg.userId}/roles`,
        method: "PATCH",
        body: queryArg.providerUpdateRolesRequest,
      }),
    }),
    getV2ProviderOrganizationsPatientVisibility: build.query<
      GetV2ProviderOrganizationsPatientVisibilityApiResponse,
      GetV2ProviderOrganizationsPatientVisibilityApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/patient-visibility` }),
    }),
    patchV2ProviderOrganizationsPatientVisibility: build.mutation<
      PatchV2ProviderOrganizationsPatientVisibilityApiResponse,
      PatchV2ProviderOrganizationsPatientVisibilityApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/patient-visibility`,
        method: "PATCH",
        body: queryArg.providerUpdatePatientVisibilityRequest,
      }),
    }),
    getV2ProviderOrganizationsRoles: build.query<
      GetV2ProviderOrganizationsRolesApiResponse,
      GetV2ProviderOrganizationsRolesApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/roles` }),
    }),
    getV2ProviderOrganizationsTemplates: build.query<
      GetV2ProviderOrganizationsTemplatesApiResponse,
      GetV2ProviderOrganizationsTemplatesApiArg
    >({
      query: () => ({ url: `/v2/provider/organizations/templates` }),
    }),
    postV2ProviderOrganizationsTemplates: build.mutation<
      PostV2ProviderOrganizationsTemplatesApiResponse,
      PostV2ProviderOrganizationsTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/templates`,
        method: "POST",
        body: queryArg.providerTemplateCreateRequest,
      }),
    }),
    deleteV2ProviderOrganizationsTemplatesByTemplateId: build.mutation<
      DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiResponse,
      DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/templates/${queryArg.templateId}`,
        method: "DELETE",
      }),
    }),
    putV2ProviderOrganizationsTemplatesByTemplateId: build.mutation<
      PutV2ProviderOrganizationsTemplatesByTemplateIdApiResponse,
      PutV2ProviderOrganizationsTemplatesByTemplateIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/organizations/templates/${queryArg.templateId}`,
        method: "PUT",
        body: queryArg.providerTemplateUpdateRequest,
      }),
    }),
    postV2ProviderV2ProviderOrganizationsMembersByUserIdReactivate:
      build.mutation<
        PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiResponse,
        PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/v2/provider/organizations/members/${queryArg.userId}/reactivate`,
          method: "POST",
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminOrganizationsApiResponse =
  /** status 200 OK */ ListResponseAdminOrganizationResponse;
export type GetV2AdminOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2AdminOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ AdminOrganizationDetailResponse;
export type GetV2AdminOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ UpdateOrganizationResponse;
export type PatchV2AdminOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
  updateOrganizationRequest: UpdateOrganizationRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdBaaApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdBaaApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdCoiApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdCoiApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiResponse =
  /** status 200 OK */ CreateSubscriptionResponse;
export type PostV2AdminOrganizationsByOrganizationIdCreateSubscriptionApiArg = {
  organizationId: string;
  createSubscriptionRequest: CreateSubscriptionRequest;
};
export type PutV2AdminOrganizationsByOrganizationIdDataRetentionApiResponse =
  /** status 200 OK */ AdminUpdateStatusResponse;
export type PutV2AdminOrganizationsByOrganizationIdDataRetentionApiArg = {
  organizationId: string;
  adminUpdateStatusRequest: AdminUpdateStatusRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdDataSecurityApiResponse =
  /** status 200 OK */ CombinedDataSecurityStatusResponse;
export type GetV2AdminOrganizationsByOrganizationIdDataSecurityApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg = {
  pathOrganizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  queryOrganizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type PostV2AdminOrganizationsByOrganizationIdExtendTrialApiResponse =
  /** status 200 OK */ ExtendTrialResponse;
export type PostV2AdminOrganizationsByOrganizationIdExtendTrialApiArg = {
  organizationId: string;
  extendTrialRequest: ExtendTrialRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdFormsApiResponse =
  /** status 200 OK */ AdminFormListResponse;
export type GetV2AdminOrganizationsByOrganizationIdFormsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdFormsApiResponse =
  /** status 200 OK */ AdminFormResponse2;
export type PostV2AdminOrganizationsByOrganizationIdFormsApiArg = {
  organizationId: string;
  adminFormCreateRequest: AdminFormCreateRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiResponse =
  /** status 200 OK */ ResourceActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdFormsAndFormIdApiArg = {
  organizationId: string;
  formId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdMembersApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersApiArg = {
  organizationId: string;
  addMemberRequest: AddMemberRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdMembersAndUserIdApiArg = {
  organizationId: string;
  userId: string;
  /** Specific role to remove (e.g., 'member', 'admin', 'clinician'). If not provided, removes all roles. */
  role?: string | null;
};
export type GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type GetV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdMembershipInfoApiArg =
  {
    organizationId: string;
    userId: string;
    updateMembershipInfoRequest: UpdateMembershipInfoRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiResponse =
  /** status 200 OK */ MemberActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdReactivateApiArg =
  {
    organizationId: string;
    userId: string;
  };
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse =
  /** status 200 OK */ RoleActionResponse;
export type PatchV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg =
  {
    organizationId: string;
    userId: string;
    updateUserRolesRequest: UpdateUserRolesRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiResponse =
  /** status 200 OK */ RoleActionResponse;
export type PostV2AdminOrganizationsByOrganizationIdMembersAndUserIdRolesApiArg =
  {
    organizationId: string;
    userId: string;
    addUserRoleRequest: AddUserRoleRequest;
  };
export type PostV2AdminOrganizationsByOrganizationIdMergeApiResponse =
  /** status 200 OK */ MergeOrganizationsResponse;
export type PostV2AdminOrganizationsByOrganizationIdMergeApiArg = {
  organizationId: string;
  mergeOrganizationsRequest: MergeOrganizationsRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse =
  /** status 200 OK */ PatientVisibilityResponse;
export type GetV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg = {
  organizationId: string;
};
export type PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiResponse =
  /** status 200 OK */ PatientVisibilityResponse;
export type PatchV2AdminOrganizationsByOrganizationIdPatientVisibilityApiArg = {
  organizationId: string;
  updatePatientVisibilityRequest: UpdatePatientVisibilityRequest;
};
export type GetV2AdminOrganizationsByOrganizationIdProvidersApiResponse =
  /** status 200 OK */ ListResponseAdminProviderResponse;
export type GetV2AdminOrganizationsByOrganizationIdProvidersApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiResponse =
  /** status 200 OK */ SubscriptionDashboardUrlResponse;
export type GetV2AdminOrganizationsByOrganizationIdSubscriptionDashboardUrlApiArg =
  {
    organizationId: string;
  };
export type PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiResponse =
  /** status 200 OK */ SyncSubscriptionResponse;
export type PostV2AdminOrganizationsByOrganizationIdSyncSubscriptionApiArg = {
  organizationId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdTemplatesApiResponse =
  /** status 200 OK */ AdminTemplateListResponse;
export type GetV2AdminOrganizationsByOrganizationIdTemplatesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrganizationsByOrganizationIdTemplatesApiResponse =
  /** status 200 OK */ AdminTemplateResponse2;
export type PostV2AdminOrganizationsByOrganizationIdTemplatesApiArg = {
  organizationId: string;
  adminTemplateCreateRequest: AdminTemplateCreateRequest;
};
export type DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ ResourceActionResponse;
export type DeleteV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg =
  {
    organizationId: string;
    templateId: string;
  };
export type PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiResponse =
  /** status 200 OK */ AdminTemplateResponse2;
export type PutV2AdminOrganizationsByOrganizationIdTemplatesAndTemplateIdApiArg =
  {
    organizationId: string;
    templateId: string;
    adminTemplateUpdateRequest: AdminTemplateUpdateRequest;
  };
export type GetV2AdminRolesApiResponse =
  /** status 200 OK */ AvailableRolesResponse;
export type GetV2AdminRolesApiArg = void;
export type GetV2ProviderOrganizationsApiResponse =
  /** status 200 OK */ ProviderOrganizationResponse;
export type GetV2ProviderOrganizationsApiArg = void;
export type PostV2ProviderOrganizationsBaaApiResponse =
  /** status 201 Created */ DataSecurityRequestResponse;
export type PostV2ProviderOrganizationsBaaApiArg = {
  baaRequest: BaaRequest;
};
export type PostV2ProviderOrganizationsBundlesApiResponse =
  /** status 201 Created */ AdminBundleActionResponse;
export type PostV2ProviderOrganizationsBundlesApiArg = {
  adminAddBundleRequest: AdminAddBundleRequest;
};
export type DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiResponse =
  unknown;
export type DeleteV2ProviderOrganizationsBundlesByAssignmentIdApiArg = {
  assignmentId: string;
};
export type PutV2ProviderOrganizationsBundlesByAssignmentIdApiResponse =
  /** status 200 OK */ AdminBundleActionResponse;
export type PutV2ProviderOrganizationsBundlesByAssignmentIdApiArg = {
  assignmentId: string;
  adminAddBundleRequest: AdminAddBundleRequest;
};
export type PostV2ProviderOrganizationsCoiApiResponse =
  /** status 201 Created */ DataSecurityRequestResponse;
export type PostV2ProviderOrganizationsCoiApiArg = {
  coiRequest: CoiRequest;
};
export type PostV2ProviderOrganizationsDataRetentionApiResponse =
  /** status 201 Created */ DataSecurityRequestResponse;
export type PostV2ProviderOrganizationsDataRetentionApiArg = {
  dataRetentionRequest: DataRetentionRequest;
};
export type GetV2ProviderOrganizationsDataSecurityApiResponse =
  /** status 200 OK */ CombinedDataSecurityStatusResponse;
export type GetV2ProviderOrganizationsDataSecurityApiArg = void;
export type GetV2ProviderOrganizationsFormsApiResponse =
  /** status 200 OK */ ProviderFormListResponse;
export type GetV2ProviderOrganizationsFormsApiArg = void;
export type PostV2ProviderOrganizationsFormsApiResponse =
  /** status 200 OK */ ProviderFormResponse2;
export type PostV2ProviderOrganizationsFormsApiArg = {
  providerFormCreateRequest: ProviderFormCreateRequest;
};
export type DeleteV2ProviderOrganizationsFormsByFormIdApiResponse =
  /** status 200 OK */ ProviderResourceActionResponse;
export type DeleteV2ProviderOrganizationsFormsByFormIdApiArg = {
  formId: string;
};
export type GetV2ProviderOrganizationsInvitationsApiResponse =
  /** status 200 OK */ ProviderInvitationListResponse;
export type GetV2ProviderOrganizationsInvitationsApiArg = void;
export type PostV2ProviderOrganizationsInvitationsApiResponse =
  /** status 200 OK */ ProviderInvitationResponse2;
export type PostV2ProviderOrganizationsInvitationsApiArg = {
  providerInvitationRequest: ProviderInvitationRequest;
};
export type PostV2ProviderOrganizationsInvitationsAcceptApiResponse =
  /** status 200 OK */ ProviderInvitationAcceptResponse;
export type PostV2ProviderOrganizationsInvitationsAcceptApiArg = {
  providerInvitationAcceptRequest: ProviderInvitationAcceptRequest;
};
export type GetV2ProviderOrganizationsInvitationsValidateByTokenApiResponse =
  /** status 200 OK */ ProviderInvitationValidationResponse;
export type GetV2ProviderOrganizationsInvitationsValidateByTokenApiArg = {
  token: string;
};
export type DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type DeleteV2ProviderOrganizationsInvitationsByInvitationIdApiArg = {
  invitationId: string;
};
export type PatchV2ProviderOrganizationsInvitationsByInvitationIdApiResponse =
  /** status 200 OK */ ProviderInvitationResponse2;
export type PatchV2ProviderOrganizationsInvitationsByInvitationIdApiArg = {
  invitationId: string;
  providerUpdateInvitationRequest: ProviderUpdateInvitationRequest;
};
export type PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PostV2ProviderOrganizationsInvitationsByInvitationIdResendApiArg = {
  invitationId: string;
};
export type GetV2ProviderOrganizationsMembersApiResponse =
  /** status 200 OK */ ProviderMemberListResponse;
export type GetV2ProviderOrganizationsMembersApiArg = void;
export type DeleteV2ProviderOrganizationsMembersByUserIdApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type DeleteV2ProviderOrganizationsMembersByUserIdApiArg = {
  userId: string;
};
export type PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdBillingInfoApiArg = {
  userId: string;
  updateMemberBillingInfoRequest: UpdateMemberBillingInfoRequest;
};
export type PostV2ProviderOrganizationsMembersByUserIdBundlesApiResponse =
  /** status 201 Created */ AdminBundleActionResponse;
export type PostV2ProviderOrganizationsMembersByUserIdBundlesApiArg = {
  userId: string;
  adminAddBundleRequest: AdminAddBundleRequest;
};
export type DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse =
  unknown;
export type DeleteV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg =
  {
    userId: string;
    assignmentId: string;
  };
export type PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiResponse =
  /** status 200 OK */ AdminBundleActionResponse;
export type PutV2ProviderOrganizationsMembersByUserIdBundlesAndAssignmentIdApiArg =
  {
    userId: string;
    assignmentId: string;
    adminAddBundleRequest: AdminAddBundleRequest;
  };
export type GetV2ProviderOrganizationsMembersByUserIdDetailApiResponse =
  /** status 200 OK */ MemberDetailResponse;
export type GetV2ProviderOrganizationsMembersByUserIdDetailApiArg = {
  userId: string;
};
export type GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type GetV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg = {
  userId: string;
};
export type PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiResponse =
  /** status 200 OK */ MembershipInfoResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdMembershipInfoApiArg = {
  userId: string;
  updateMembershipInfoRequest: UpdateMembershipInfoRequest;
};
export type PatchV2ProviderOrganizationsMembersByUserIdProfileApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdProfileApiArg = {
  userId: string;
  updateMemberProfileRequest: UpdateMemberProfileRequest;
};
export type PatchV2ProviderOrganizationsMembersByUserIdRolesApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PatchV2ProviderOrganizationsMembersByUserIdRolesApiArg = {
  userId: string;
  providerUpdateRolesRequest: ProviderUpdateRolesRequest;
};
export type GetV2ProviderOrganizationsPatientVisibilityApiResponse =
  /** status 200 OK */ ProviderPatientVisibilityResponse;
export type GetV2ProviderOrganizationsPatientVisibilityApiArg = void;
export type PatchV2ProviderOrganizationsPatientVisibilityApiResponse =
  /** status 200 OK */ ProviderPatientVisibilityResponse;
export type PatchV2ProviderOrganizationsPatientVisibilityApiArg = {
  providerUpdatePatientVisibilityRequest: ProviderUpdatePatientVisibilityRequest;
};
export type GetV2ProviderOrganizationsRolesApiResponse =
  /** status 200 OK */ ProviderRoleListResponse;
export type GetV2ProviderOrganizationsRolesApiArg = void;
export type GetV2ProviderOrganizationsTemplatesApiResponse =
  /** status 200 OK */ ProviderTemplateListResponse;
export type GetV2ProviderOrganizationsTemplatesApiArg = void;
export type PostV2ProviderOrganizationsTemplatesApiResponse =
  /** status 200 OK */ ProviderTemplateResponse2;
export type PostV2ProviderOrganizationsTemplatesApiArg = {
  providerTemplateCreateRequest: ProviderTemplateCreateRequest;
};
export type DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiResponse =
  /** status 200 OK */ ProviderResourceActionResponse;
export type DeleteV2ProviderOrganizationsTemplatesByTemplateIdApiArg = {
  templateId: string;
};
export type PutV2ProviderOrganizationsTemplatesByTemplateIdApiResponse =
  /** status 200 OK */ ProviderTemplateResponse2;
export type PutV2ProviderOrganizationsTemplatesByTemplateIdApiArg = {
  templateId: string;
  providerTemplateUpdateRequest: ProviderTemplateUpdateRequest;
};
export type PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiResponse =
  /** status 200 OK */ ProviderMemberActionResponse;
export type PostV2ProviderV2ProviderOrganizationsMembersByUserIdReactivateApiArg =
  {
    userId: string;
  };
export type AdminOrganizationResponse = {
  /** Total number of admins */
  admin_count?: number;
  /** Billing admin user ID */
  billing_admin_id?: string | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Total number of members */
  member_count?: number;
  /** Organization name */
  name: string;
  /** Unique organization identifier */
  organization_id: string;
};
export type ListResponseAdminOrganizationResponse = {
  items: AdminOrganizationResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type AdminOrganizationMemberResponse = {
  /** User email */
  email?: string | null;
  /** User name */
  name?: string | null;
  /** User's payment status */
  payment_status?: string | null;
  /** Role in organization */
  role: string;
  /** User ID */
  user_id: string;
  /** Full user info object */
  user_info?: {
    [key: string]: any;
  } | null;
  /** User's metrics data */
  user_metrics?: {
    [key: string]: any;
  } | null;
};
export type AdminOrganizationUserResponse = {
  /** ISO timestamp when user was deactivated (null if active) */
  deactivated_at?: string | null;
  /** User email */
  email?: string | null;
  /** User name */
  name?: string | null;
  /** User's payment status */
  payment_status?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
  /** Full user info object */
  user_info?: {
    [key: string]: any;
  } | null;
  /** User's metrics data */
  user_metrics?: {
    [key: string]: any;
  } | null;
};
export type AdminOrganizationDetailResponse = {
  /** Billing admin details */
  billing_admin?: AdminOrganizationMemberResponse | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Full organization metadata */
  group_info?: {
    [key: string]: any;
  };
  /** Organization name */
  name: string;
  /** Unique organization identifier */
  organization_id: string;
  /** Stripe subscription status from webhook (stored in stripe_info) */
  stripe_status_from_webhook?: string | null;
  /** Full Stripe subscription details including status, billing period, and payment info */
  stripe_subscription_details?: {
    [key: string]: any;
  } | null;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Number of seats/users in the subscription */
  stripe_subscription_quantity?: number | null;
  /** All organization users with their roles and status (including inactive) */
  users?: AdminOrganizationUserResponse[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type UpdateOrganizationResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID that was updated */
  organization_id: string;
  /** Whether the update was successful */
  success: boolean;
  /** Fields that were updated with their new values */
  updated_fields?: {
    [key: string]: any;
  };
};
export type UpdateOrganizationRequest = {
  /** New organization name */
  name?: string | null;
};
export type AdminUpdateStatusResponse = {
  /** User-friendly message */
  message: string;
  /** Status after update */
  new_status: string;
  /** Organization ID */
  organization_id: string;
  /** Status before update */
  previous_status: string;
  /** Service updated: 'baa', 'coi', or 'retention' */
  service: string;
  /** Whether the update succeeded */
  success: boolean;
  /** ISO 8601 timestamp */
  updated_at: string;
};
export type AdminUpdateStatusRequest = {
  /** Admin notes for audit trail */
  notes?: string | null;
  /** New status: 'not_configured', 'processing', or 'active' */
  status: string;
};
export type CreateSubscriptionResponse = {
  /** Stripe customer ID */
  customer_id?: string | null;
  /** Error details if the operation failed */
  error?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Number of seats on the subscription */
  quantity?: number | null;
  /** Stripe subscription ID */
  subscription_id?: string | null;
  /** Whether the subscription was created */
  success: boolean;
  /** Number of trial days */
  trial_days?: number | null;
};
export type CreateSubscriptionRequest = {
  /** Number of trial days (0-365). Defaults to STRIPE_NUM_FREE_TRIAL_DAYS env var if not provided. */
  trial_days?: number | null;
};
export type BaaStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** Entity name from request */
  entity_name?: string | null;
  /** UUID if requested */
  request_id?: string | null;
  /** ISO 8601 timestamp */
  requested_at?: string | null;
  /** BAA status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
};
export type CoiStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** Business name from request */
  business_name?: string | null;
  /** UUID if requested */
  request_id?: string | null;
  /** ISO 8601 timestamp */
  requested_at?: string | null;
  /** COI status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
};
export type DataRetentionStatusResponse = {
  /** ISO 8601 timestamp (if active) */
  activated_at?: string | null;
  /** ISO 8601 timestamp */
  configured_at?: string | null;
  /** UUID if configured */
  request_id?: string | null;
  /** Status: 'not_entitled', 'not_configured', 'processing', 'active' */
  status: string;
  /** Current setting */
  unsigned_notes_retention_days?: number | null;
};
export type CombinedDataSecurityStatusResponse = {
  /** BAA status */
  baa: BaaStatusResponse;
  /** Certificate of Insurance status */
  coi: CoiStatusResponse;
  /** Data retention policy status */
  data_retention: DataRetentionStatusResponse;
  /** Whether user has any data security capability */
  has_bundle: boolean;
};
export type CommunicationChannelStatus = {
  /** Communication channel: 'sms' or 'email' */
  channel: string;
  /** When message was delivered */
  delivered_at?: string | null;
  /** Error details if delivery failed */
  error_message?: string | null;
  /** When delivery failed */
  failed_at?: string | null;
  /** When message was sent */
  sent_at?: string | null;
  /** Delivery status: queued, sent, delivered, failed, bounced, dropped, opened, clicked */
  status: string;
};
export type FormStatusInfo = {
  /** ID of the form session */
  form_session_id: string;
  /** Form status: pending, in_progress, or completed */
  status: string;
  /** When the form was submitted */
  submitted_at?: string | null;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type DocumentSummaryResponse = {
  /** Per-channel delivery status if document was sent to patient */
  communication_status?: CommunicationChannelStatus[] | null;
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  /** Unique identifier for the document */
  document_id: string;
  /** User-friendly title for the document */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'claim', 'form') */
  document_type?: string | null;
  /** Original filename */
  filename: string;
  /** Form lifecycle status if document originated from a form submission */
  form_status?: FormStatusInfo | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  /** File size in bytes */
  size_bytes: number;
};
export type DocumentListResponse = {
  items: DocumentSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ExtendTrialResponse = {
  /** Error details if the operation failed */
  error?: string | null;
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Current subscription status */
  subscription_status?: string | null;
  /** Whether the trial extension was successful */
  success: boolean;
  /** New trial end date in ISO format */
  trial_end?: string | null;
};
export type ExtendTrialRequest = {
  /** Number of days to extend the trial (1-365) */
  days: number;
};
export type AdminFormResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Form ID */
  form_id: string;
  /** Whether the form is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
};
export type AdminFormListResponse = {
  /** List of forms */
  forms?: AdminFormResponse[];
  /** Total number of forms */
  total_count?: number;
};
export type AdminFormResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Form ID */
  form_id: string;
  /** Whether the form is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
};
export type AdminFormCreateRequest = {
  /** Form ID to add */
  form_id: string;
};
export type ResourceActionResponse = {
  /** Error message if operation failed */
  error?: string | null;
  /** Response message */
  message?: string | null;
  /** ID of the affected resource */
  resource_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
};
export type MemberActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID that was modified */
  organization_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
  /** User ID that was affected */
  user_id?: string | null;
};
export type AddMemberRequest = {
  /** Optional list of bundle IDs to assign to the user */
  bundle_ids?: string[] | null;
  /** Role to assign to the user (e.g., 'member', 'admin', 'clinician', 'operations_support', 'practice_administrator', 'supervisor') */
  role: string;
  /** User ID to add to the organization */
  user_id: string;
};
export type MembershipInfoResponse = {
  /** Human-readable message */
  message: string;
  /** Current co-sign requirement status */
  needs_cosign: boolean;
  /** Organization ID */
  organization_id: string;
  /** Whether the operation was successful */
  success: boolean;
  /** User ID */
  user_id: string;
};
export type UpdateMembershipInfoRequest = {
  /** Whether this member's notes require co-signature from a supervisor */
  needs_cosign: boolean;
};
export type RoleActionResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Current roles after the operation */
  roles?: string[];
  /** Whether the operation was successful */
  success: boolean;
  /** User ID that was affected */
  user_id: string;
};
export type UpdateUserRolesRequest = {
  /** Complete list of roles to assign to the user */
  roles: string[];
};
export type AddUserRoleRequest = {
  /** Role to add to the user (e.g., 'clinician', 'supervisor') */
  role: string;
};
export type MergeOrganizationsResponse = {
  /** Number of encounters transferred */
  encounters_moved?: number;
  /** Error details if the operation failed */
  error?: string | null;
  /** Number of memberships transferred */
  memberships_moved?: number;
  /** Human-readable message about the operation */
  message: string;
  /** Number of notes transferred */
  notes_moved?: number;
  /** Number of patients transferred */
  patients_moved?: number;
  /** Whether the source organization was successfully deleted */
  source_deleted?: boolean;
  /** Organization that was merged and deleted */
  source_organization_id: string;
  /** User ID whose organization was merged (if provided in request) */
  source_user_id?: string | null;
  /** Whether the merge was successful */
  success: boolean;
  /** Organization that received the members */
  target_organization_id: string;
};
export type MergeOrganizationsRequest = {
  /** Roles to assign to the merged user in the target organization (e.g., ['admin', 'member']) */
  roles?: string[] | null;
  /** Organization ID to merge FROM (will be deleted) */
  source_organization_id?: string | null;
  /** User ID whose organization should be merged FROM */
  source_user_id?: string | null;
};
export type PatientVisibilityResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Current patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
  /** Organization ID */
  organization_id: string;
  /** Whether the operation was successful */
  success: boolean;
};
export type UpdatePatientVisibilityRequest = {
  /** Patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
};
export type AdminProviderUserInfo = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  profile_picture?: string | null;
};
export type AdminProviderUserMetrics = {
  notes_created?: number | null;
};
export type AdminProviderResponse = {
  created_at?: string | null;
  email?: string | null;
  email_verified?: boolean | null;
  last_login_time?: string | null;
  name?: string | null;
  note_count?: number | null;
  organization_id?: string | null;
  payment_status?: string | null;
  provider_id: string;
  role: string;
  user_info?: AdminProviderUserInfo | null;
  user_metrics?: AdminProviderUserMetrics | null;
};
export type ListResponseAdminProviderResponse = {
  items: AdminProviderResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type SubscriptionDashboardUrlResponse = {
  /** Stripe dashboard URL for viewing the subscription */
  dashboard_url: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  subscription_id: string;
};
export type SyncSubscriptionResponse = {
  /** Billing admin user ID */
  billing_admin_id?: string | null;
  /** Number of billable members */
  member_count?: number | null;
  /** Human-readable message about the sync */
  message: string;
  /** Organization ID */
  organization_id: string;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Updated subscription quantity */
  subscription_quantity?: number | null;
  /** Whether the sync was successful */
  success: boolean;
  /** Whether a webhook was triggered */
  webhook_triggered?: boolean;
};
export type AdminTemplateResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Whether the template is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
  /** Template ID */
  template_id: string;
};
export type AdminTemplateListResponse = {
  /** List of templates */
  templates?: AdminTemplateResponse[];
  /** Total number of templates */
  total_count?: number;
};
export type AdminTemplateResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Deletion timestamp (for soft deletes) */
  deleted_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Whether the template is active (not deleted) */
  is_active?: boolean;
  /** Organization ID */
  organization_id: string;
  /** Template ID */
  template_id: string;
};
export type AdminTemplateCreateRequest = {
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID to add */
  template_id: string;
};
export type AdminTemplateUpdateRequest = {
  /** New display name for the template */
  display_name: string;
};
export type RoleDefinition = {
  /** Whether this role has admin-level permissions */
  is_admin_equivalent: boolean;
  /** Whether this role counts for billing */
  is_billable: boolean;
  /** Whether this is a legacy role (for backward compatibility) */
  is_legacy: boolean;
  /** Whether this role has member-level permissions */
  is_member_equivalent: boolean;
  /** Role identifier */
  role: string;
};
export type AvailableRolesResponse = {
  /** List of roles that count for billing */
  billable_roles: string[];
  /** List of current (non-legacy) role identifiers */
  current_roles: string[];
  /** List of legacy role identifiers */
  legacy_roles: string[];
  /** List of all available roles */
  roles: RoleDefinition[];
};
export type ProviderOrganizationResponse = {
  /** URL to Stripe billing portal for self-service */
  billing_portal_url?: string | null;
  /** ISO timestamp of creation */
  created_at?: string | null;
  /** Total inactive member count */
  inactive_member_count?: number;
  /** Total active member count */
  member_count?: number;
  /** Organization name */
  name: string;
  /** Number of available seats */
  seat_count?: number | null;
  /** Subscription status (active/trial/expired) */
  subscription_status?: string | null;
};
export type DataSecurityRequestResponse = {
  /** ISO 8601 timestamp */
  created_at: string;
  /** User-friendly message */
  message: string;
  /** UUID of the request */
  request_id: string;
  /** Request status (processing) */
  status: string;
};
export type BaaRequest = {
  /** Contact email */
  email: string;
  /** Covered entity / practice name */
  entity_name: string;
  /** Contact name */
  name: string;
};
export type MemberBundleResponse = {
  /** Assignment UUID for management operations */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle display name */
  bundle_name?: string | null;
  /** 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** When bundle became active */
  effective_from?: string | null;
  /** When bundle ends */
  effective_to?: string | null;
  /** Assignment status */
  status: string;
};
export type AdminBundleActionResponse = {
  /** Full assignment details */
  assignment?: MemberBundleResponse | null;
  /** Assignment ID */
  assignment_id?: string | null;
  /** Result message */
  message: string;
  /** Whether action succeeded */
  success: boolean;
};
export type AdminAddBundleRequest = {
  /** Bundle UUID to add */
  bundle_id: string;
};
export type CoiAddressRequest = {
  /** City */
  city: string;
  /** Country code */
  country?: string;
  /** Street address line 1 */
  line1: string;
  /** Street address line 2 */
  line2?: string | null;
  /** State */
  state: string;
  /** ZIP code */
  zip: string;
};
export type CoiRequest = {
  /** Business address */
  address: CoiAddressRequest;
  /** Business/organization name */
  business_name: string;
};
export type DataRetentionRequest = {
  /** Days to retain unsigned notes. null = no auto-delete. Common values: 30, 60, 90, 180, 365 */
  unsigned_notes_retention_days?: number | null;
};
export type ProviderFormResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Form ID */
  form_id: string;
};
export type ProviderFormListResponse = {
  /** List of forms */
  forms?: ProviderFormResponse[];
  /** Total number of forms */
  total_count?: number;
};
export type ProviderFormResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Form ID */
  form_id: string;
};
export type ProviderFormCreateRequest = {
  /** Form ID to add */
  form_id: string;
};
export type ProviderResourceActionResponse = {
  /** Response message */
  message?: string | null;
  /** ID of the affected resource */
  resource_id?: string | null;
  /** Whether the operation was successful */
  success: boolean;
};
export type ProviderInvitationResponse = {
  /** Bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[];
  /** Invited email address */
  email: string;
  /** ISO timestamp when invitation expires */
  expires_at: string;
  /** Unique invitation identifier */
  invitation_id: string;
  /** True if this replaced a previous expired invitation */
  resent?: boolean;
  /** Role to be assigned */
  role: string;
  /** ISO timestamp when invitation was sent */
  sent_at: string;
  /** Invitation status */
  status?: string;
};
export type ProviderInvitationListResponse = {
  /** List of pending invitations */
  invitations?: ProviderInvitationResponse[];
  /** Total number of pending invitations */
  total_count?: number;
};
export type ProviderInvitationResponse2 = {
  /** Bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[];
  /** Invited email address */
  email: string;
  /** ISO timestamp when invitation expires */
  expires_at: string;
  /** Unique invitation identifier */
  invitation_id: string;
  /** True if this replaced a previous expired invitation */
  resent?: boolean;
  /** Role to be assigned */
  role: string;
  /** ISO timestamp when invitation was sent */
  sent_at: string;
  /** Invitation status */
  status?: string;
};
export type ProviderInvitationRequest = {
  /** Bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[];
  /** Email address to invite */
  email: string;
  /** Role to assign to the invited user */
  role: string;
};
export type ProviderInvitationAcceptResponse = {
  /** Human-readable result message */
  message: string;
  /** Organization ID if successful */
  organization_id?: string | null;
  /** Roles assigned to user */
  roles?: string[];
  /** Whether acceptance succeeded */
  success: boolean;
};
export type ProviderInvitationAcceptRequest = {
  /** Invitation token from email */
  token: string;
};
export type ProviderInvitationValidationResponse = {
  /** Whether the user can accept (false if in multi-member org) */
  can_accept?: boolean | null;
  /** Error message if invalid */
  error?: string | null;
  /** When the invitation expires */
  expires_at?: string | null;
  /** Display name of the user who sent the invitation */
  invited_by_name?: string | null;
  /** Email address the invitation was sent to */
  invited_email?: string | null;
  /** Display name of the inviting organization */
  organization_name?: string | null;
  /** Role to be assigned when accepted */
  role?: string | null;
  /** Invitation status (pending/accepted/expired/cancelled) */
  status?: string | null;
  /** Whether the invitation is valid */
  valid: boolean;
};
export type ProviderMemberActionResponse = {
  /** Human-readable result message */
  message: string;
  /** Whether the action succeeded */
  success: boolean;
  /** Affected user ID */
  user_id?: string | null;
};
export type ProviderUpdateInvitationRequest = {
  /** New bundle IDs to assign when invitation is accepted */
  bundle_ids?: string[] | null;
  /** New role to assign */
  role?: string | null;
};
export type ProviderLicenseType =
  | "MD"
  | "DO"
  | "PhD"
  | "PsyD"
  | "LCSW"
  | "LMSW"
  | "LISW"
  | "LICSW"
  | "LCSW-C"
  | "LMFT"
  | "LPC"
  | "LCPC"
  | "LPCC"
  | "LMHC"
  | "LCMHC"
  | "NP"
  | "PMHNP"
  | "APRN"
  | "CNS"
  | "PA"
  | "RN"
  | "LADC"
  | "LCADC"
  | "CADC"
  | "BCBA"
  | "PSYCH_ASSOC"
  | "PASTORAL"
  | "OTHER";
export type MemberBillingInfo = {
  /** Accept insurance payment as full */
  accept_insurance_payment_as_full?: string | null;
  /** Override org default billing entity for claims */
  billing_entity_id?: string | null;
  /** Billing NPI (if different) */
  billing_npi_number?: string | null;
  /** City */
  city?: string | null;
  /** Name used in communications */
  communications_name?: string | null;
  /** Facility address line 1 */
  facility_address?: string | null;
  /** Facility address line 2 */
  facility_address2?: string | null;
  /** Fax number */
  fax_number?: string | null;
  /** First name for billing */
  first_name?: string | null;
  /** Last name for billing */
  last_name?: string | null;
  /** License number */
  license_number?: string | null;
  /** State of licensure */
  license_state?: string | null;
  /** Provider license type (MD, DO, LCSW, etc.) */
  license_type?: ProviderLicenseType | null;
  /** Provider NPI number */
  npi_number?: string | null;
  /** Phone number */
  phone?: string | null;
  /** Place of service code */
  place_of_service?: string | null;
  /** Name used for signing */
  signing_name?: string | null;
  /** State */
  state?: string | null;
  /** Tax ID (EIN or SSN) */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type MemberBundleResponse2 = {
  /** Assignment UUID for management operations */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle display name */
  bundle_name?: string | null;
  /** 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** When bundle became active */
  effective_from?: string | null;
  /** When bundle ends */
  effective_to?: string | null;
  /** Assignment status */
  status: string;
};
export type ProviderOrganizationMemberResponse = {
  /** Provider billing information */
  billing_info?: MemberBillingInfo | null;
  /** Bundle assignments for this member (org-level + user-specific) */
  bundles?: MemberBundleResponse2[];
  /** ISO timestamp when user was deactivated */
  deactivated_at?: string | null;
  /** User email */
  email?: string | null;
  /** User mobile phone number (E.164 format) */
  mobile_phone_num?: string | null;
  /** User name */
  name?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
};
export type ProviderMemberListResponse = {
  /** List of organization members */
  members?: ProviderOrganizationMemberResponse[];
  /** Total number of members */
  total_count?: number;
};
export type ProviderLicenseType2 =
  | "MD"
  | "DO"
  | "PhD"
  | "PsyD"
  | "LCSW"
  | "LMSW"
  | "LISW"
  | "LICSW"
  | "LCSW-C"
  | "LMFT"
  | "LPC"
  | "LCPC"
  | "LPCC"
  | "LMHC"
  | "LCMHC"
  | "NP"
  | "PMHNP"
  | "APRN"
  | "CNS"
  | "PA"
  | "RN"
  | "LADC"
  | "LCADC"
  | "CADC"
  | "BCBA"
  | "PSYCH_ASSOC"
  | "PASTORAL"
  | "OTHER";
export type UpdateMemberBillingInfoRequest = {
  /** Accept insurance payment as full */
  accept_insurance_payment_as_full?: string | null;
  /** Override org default billing entity for claims */
  billing_entity_id?: string | null;
  /** Billing NPI (if different) */
  billing_npi_number?: string | null;
  /** City */
  city?: string | null;
  /** Name used in communications */
  communications_name?: string | null;
  /** Facility address line 1 */
  facility_address?: string | null;
  /** Facility address line 2 */
  facility_address2?: string | null;
  /** Fax number */
  fax_number?: string | null;
  /** First name for billing */
  first_name?: string | null;
  /** Last name for billing */
  last_name?: string | null;
  /** License number */
  license_number?: string | null;
  /** State of licensure */
  license_state?: string | null;
  /** Provider license type (MD, DO, LCSW, etc.) */
  license_type?: ProviderLicenseType2 | null;
  /** Provider NPI number */
  npi_number?: string | null;
  /** Phone number */
  phone?: string | null;
  /** Place of service code */
  place_of_service?: string | null;
  /** Name used for signing */
  signing_name?: string | null;
  /** State */
  state?: string | null;
  /** Tax ID (EIN or SSN) */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ProviderLicenseType3 =
  | "MD"
  | "DO"
  | "PhD"
  | "PsyD"
  | "LCSW"
  | "LMSW"
  | "LISW"
  | "LICSW"
  | "LCSW-C"
  | "LMFT"
  | "LPC"
  | "LCPC"
  | "LPCC"
  | "LMHC"
  | "LCMHC"
  | "NP"
  | "PMHNP"
  | "APRN"
  | "CNS"
  | "PA"
  | "RN"
  | "LADC"
  | "LCADC"
  | "CADC"
  | "BCBA"
  | "PSYCH_ASSOC"
  | "PASTORAL"
  | "OTHER";
export type MemberBillingInfo2 = {
  /** Accept insurance payment as full */
  accept_insurance_payment_as_full?: string | null;
  /** Override org default billing entity for claims */
  billing_entity_id?: string | null;
  /** Billing NPI (if different) */
  billing_npi_number?: string | null;
  /** City */
  city?: string | null;
  /** Name used in communications */
  communications_name?: string | null;
  /** Facility address line 1 */
  facility_address?: string | null;
  /** Facility address line 2 */
  facility_address2?: string | null;
  /** Fax number */
  fax_number?: string | null;
  /** First name for billing */
  first_name?: string | null;
  /** Last name for billing */
  last_name?: string | null;
  /** License number */
  license_number?: string | null;
  /** State of licensure */
  license_state?: string | null;
  /** Provider license type (MD, DO, LCSW, etc.) */
  license_type?: ProviderLicenseType3 | null;
  /** Provider NPI number */
  npi_number?: string | null;
  /** Phone number */
  phone?: string | null;
  /** Place of service code */
  place_of_service?: string | null;
  /** Name used for signing */
  signing_name?: string | null;
  /** State */
  state?: string | null;
  /** Tax ID (EIN or SSN) */
  tax_id?: string | null;
  /** Tax ID type (EIN or SSN) */
  tax_id_type?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type MemberBundleResponse3 = {
  /** Assignment UUID for management operations */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle display name */
  bundle_name?: string | null;
  /** 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** When bundle became active */
  effective_from?: string | null;
  /** When bundle ends */
  effective_to?: string | null;
  /** Assignment status */
  status: string;
};
export type MemberDetailResponse = {
  /** Provider billing information */
  billing_info?: MemberBillingInfo2 | null;
  /** Bundle assignments for this member (org-level + user-specific) */
  bundles?: MemberBundleResponse3[];
  /** ISO timestamp when user was deactivated */
  deactivated_at?: string | null;
  /** User email */
  email?: string | null;
  /** First name */
  first_name?: string | null;
  /** Last name */
  last_name?: string | null;
  /** User mobile phone number (E.164 format) */
  mobile_phone_num?: string | null;
  /** User name */
  name?: string | null;
  /** List of roles in organization */
  roles?: string[];
  /** Membership status: 'active' or 'inactive' */
  status?: string;
  /** User ID */
  user_id: string;
};
export type UpdateMemberProfileRequest = {
  /** Email address */
  email?: string | null;
  /** First name */
  first_name?: string | null;
  /** Last name */
  last_name?: string | null;
  /** Mobile phone number (E.164 format, e.g., +15551234567) */
  mobile_phone_num?: string | null;
};
export type ProviderUpdateRolesRequest = {
  /** New complete list of roles for the user */
  roles: string[];
};
export type ProviderPatientVisibilityResponse = {
  /** Human-readable message about the operation */
  message: string;
  /** Current patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
  /** Whether the operation was successful */
  success: boolean;
};
export type ProviderUpdatePatientVisibilityRequest = {
  /** Patient visibility mode: 'organization_wide' or 'provider_only' */
  mode: string;
};
export type ProviderRoleInfo = {
  /** Role description */
  description: string;
  /** Human-readable role name */
  display_name: string;
  /** Whether this role has admin privileges */
  is_admin?: boolean;
  /** Whether this role is billable */
  is_billable?: boolean;
  /** Role identifier */
  role: string;
};
export type ProviderRoleListResponse = {
  /** List of available roles */
  roles?: ProviderRoleInfo[];
};
export type ProviderTemplateResponse = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID */
  template_id: string;
};
export type ProviderTemplateListResponse = {
  /** List of templates */
  templates?: ProviderTemplateResponse[];
  /** Total number of templates */
  total_count?: number;
};
export type ProviderTemplateResponse2 = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID */
  template_id: string;
};
export type ProviderTemplateCreateRequest = {
  /** Display name for the template */
  display_name?: string | null;
  /** Template ID to add */
  template_id: string;
};
export type ProviderTemplateUpdateRequest = {
  /** New display name for the template */
  display_name: string;
};
